import { useSelector } from 'react-redux';
import {
  selectGuaranteesAmTemplateDocument,
  selectGuaranteesAmTemplateDocumentStatus,
} from '~/store/guarantees/selectors.ts';
import { useGuaranteesPdfPreview } from '../../shared/hooks/useGuaranteesPdfPreview.ts';
import { MANAGER_APPROVAL_LETTER_MISSING_PDF_TEXT } from './constants.ts';

type TSetModalAlert = (value: { text: string }) => void;

export const useManagerApprovalLetterPdfPreview = ({
  setModalAlert,
}: {
  setModalAlert: TSetModalAlert;
}) => {
  const amTemplateDocument = useSelector(selectGuaranteesAmTemplateDocument);
  const amTemplateDocumentStatus = useSelector(selectGuaranteesAmTemplateDocumentStatus);

  return useGuaranteesPdfPreview({
    contentType: amTemplateDocument?.contentType,
    documentBlob: amTemplateDocument?.data,
    missingPdfText: MANAGER_APPROVAL_LETTER_MISSING_PDF_TEXT,
    setModalAlert,
    status: amTemplateDocumentStatus,
  });
};
